/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hourglass'
export default icon
